import { Navigate, Route, Routes } from "react-router-dom";

// 會員端
import Splash from "./pages/Splash";
import Join from "./pages/Join";
import CompleteProfile from "./pages/CompleteProfile";
import Home from "./pages/Home";
import MemberProfile from "./pages/MemberProfile";
import Beneficiaries from "./pages/Beneficiaries";
import Products from "./pages/Products";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import OrderComplete from "./pages/OrderComplete";
import OrderHistory from "./pages/OrderHistory";
import Wallet from "./pages/Wallet";
import GiftWizard from "./pages/GiftWizard";
import GiftSent from "./pages/GiftSent";
import GiftReceive from "./pages/GiftReceive";
import GiftHistory from "./pages/GiftHistory";
import Traceability from "./pages/Traceability";
import BanquetReserve from "./pages/BanquetReserve";
import BrandFounder from "./pages/BrandFounder";
import BrandEvent from "./pages/BrandEvent";
import BrandNaming from "./pages/BrandNaming";
import BrandTasting from "./pages/BrandTasting";

// 後台
import AdminLogin from "./pages/admin/AdminLogin";
import Dashboard from "./pages/admin/Dashboard";
import MemberList from "./pages/admin/MemberList";
import MemberDetail from "./pages/admin/MemberDetail";
import MemberCreate from "./pages/admin/MemberCreate";
import MemberDuplicates from "./pages/admin/MemberDuplicates";
import OrderList from "./pages/admin/OrderList";
import OrderDetail from "./pages/admin/OrderDetail";
import OrderCreate from "./pages/admin/OrderCreate";
import DirectShip from "./pages/admin/DirectShip";
import ShipmentList from "./pages/admin/ShipmentList";
import Forecast from "./pages/admin/Forecast";
import Supply from "./pages/admin/Supply";
import SupplyBatch from "./pages/admin/SupplyBatch";
import CodeManage from "./pages/admin/CodeManage";
import ProductList from "./pages/admin/ProductList";
import ProductEdit from "./pages/admin/ProductEdit";
import CategoryManage from "./pages/admin/CategoryManage";
import TraceabilityManage from "./pages/admin/TraceabilityManage";
import BrandEventManage from "./pages/admin/BrandEventManage";
import BanquetReservations from "./pages/admin/BanquetReservations";
import InteractionAnalytics from "./pages/admin/InteractionAnalytics";
import AdminAccount from "./pages/admin/AdminAccount";
import AdminSettings from "./pages/admin/AdminSettings";

import Toast from "./components/Toast";


export default function App() {
  return (
    <>
      <Routes>
        {/* 會員端 */}
        <Route path="/" element={<Splash />} />
        <Route path="/join" element={<Join />} />
        <Route path="/complete-profile" element={<CompleteProfile />} />
        <Route path="/home" element={<Home />} />
        <Route path="/profile" element={<MemberProfile />} />
        <Route path="/beneficiaries" element={<Beneficiaries />} />
        <Route path="/products" element={<Products />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/orders" element={<OrderHistory />} />
        <Route path="/orders/:id" element={<OrderComplete />} />
        <Route path="/wallet" element={<Wallet />} />
        <Route path="/gift/new" element={<GiftWizard />} />
        <Route path="/gift/sent/:id" element={<GiftSent />} />
        <Route path="/gift/receive/:id" element={<GiftReceive />} />
        <Route path="/gift/history" element={<GiftHistory />} />
        <Route path="/traceability" element={<Traceability />} />
        <Route path="/banquet" element={<BanquetReserve />} />
        <Route path="/brand/founder" element={<BrandFounder />} />
        <Route path="/brand/events/:slug" element={<BrandEvent />} />
        <Route path="/brand/naming" element={<BrandNaming />} />
        <Route path="/brand/tasting/:slug" element={<BrandTasting />} />

        {/* 後台（不掛 LIFF SDK，用 email + password 登入）*/}
        <Route path="/admin" element={<Dashboard />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/members" element={<MemberList />} />
        <Route path="/admin/members/new" element={<MemberCreate />} />
        <Route path="/admin/members/duplicates" element={<MemberDuplicates />} />
        <Route path="/admin/members/:uid" element={<MemberDetail />} />
        <Route path="/admin/orders" element={<OrderList />} />
        <Route path="/admin/orders/new" element={<OrderCreate />} />
        <Route path="/admin/orders/:id" element={<OrderDetail />} />
        <Route path="/admin/ship" element={<DirectShip />} />
        <Route path="/admin/shipments" element={<ShipmentList />} />
        <Route path="/admin/forecast" element={<Forecast />} />
        <Route path="/admin/supply" element={<Supply />} />
        <Route path="/admin/supply/batches/:id" element={<SupplyBatch />} />
        <Route path="/admin/banquet" element={<BanquetReservations />} />
        <Route path="/admin/codes" element={<CodeManage />} />
        <Route path="/admin/products" element={<ProductList />} />
        <Route path="/admin/categories" element={<CategoryManage />} />
        <Route path="/admin/traceability" element={<TraceabilityManage />} />
        <Route path="/admin/brand-events" element={<BrandEventManage />} />
        <Route path="/admin/interactions" element={<InteractionAnalytics />} />
        <Route path="/admin/products/:id" element={<ProductEdit />} />
        <Route path="/admin/account" element={<AdminAccount />} />
        <Route path="/admin/settings" element={<AdminSettings />} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toast />
    </>
  );
}
